import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  setSearchParams,
  toPathString,
} from '../common';
import {
  IntercomDeviceLogListResponse,
  IntercomDeviceLogDeviceStatisticsResponse,
  IntercomDeviceLogRecentActivitiesResponse,
} from '../types/intercomDeviceLog';

export const IntercomDeviceLogServiceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * 获取组织的对讲机审计日志
     * @summary 获取组织的对讲机审计日志
     * @param {string} orgId
     * @param {string} [operationType]
     * @param {string} [status]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [page]
     * @param {string} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntercomDeviceAuditLogs: async (
      orgId: string,
      operationType?: string,
      status?: string,
      startDate?: string,
      endDate?: string,
      page?: string,
      limit?: string,
      userId?: string,
      apartmentId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('getIntercomDeviceAuditLogs', 'orgId', orgId);
      const localVarPath = `/intercom_logs/organization/${encodeURIComponent(
        String(orgId)
      )}/audit_logs`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (operationType !== undefined) localVarQueryParameter['operationType'] = operationType;
      if (status !== undefined) localVarQueryParameter['status'] = status;
      if (startDate !== undefined) localVarQueryParameter['startDate'] = startDate;
      if (endDate !== undefined) localVarQueryParameter['endDate'] = endDate;
      if (page !== undefined) localVarQueryParameter['page'] = page;
      if (limit !== undefined) localVarQueryParameter['limit'] = limit;
      if (userId !== undefined) localVarQueryParameter['userId'] = userId;
      if (apartmentId !== undefined) localVarQueryParameter['apartmentId'] = apartmentId;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * 获取多个设备的统计数据
     * @summary 获取多个设备的统计数据
     * @param {string} deviceIds
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMultipleDevicesStatistics: async (
      deviceIds: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('getMultipleDevicesStatistics', 'deviceIds', deviceIds);
      const localVarPath = `/intercom_logs/device/statistics`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (deviceIds !== undefined) localVarQueryParameter['deviceIds'] = deviceIds;
      if (startDate !== undefined) localVarQueryParameter['startDate'] = startDate;
      if (endDate !== undefined) localVarQueryParameter['endDate'] = endDate;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * 获取多个设备的最近活动
     * @summary 获取多个设备的最近活动
     * @param {string} deviceIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecentActivities: async (
      deviceIds: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('getRecentActivities', 'deviceIds', deviceIds);
      const localVarPath = `/intercom_logs/devices/recent_activities`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (deviceIds !== undefined) localVarQueryParameter['deviceIds'] = deviceIds;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export const IntercomDeviceLogServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IntercomDeviceLogServiceApiAxiosParamCreator(configuration);
  return {
    async getIntercomDeviceAuditLogs(
      orgId: string,
      operationType?: string,
      status?: string,
      startDate?: string,
      endDate?: string,
      page?: string,
      limit?: string,
      userId?: string,
      apartmentId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntercomDeviceLogListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getIntercomDeviceAuditLogs(
        orgId,
        operationType,
        status,
        startDate,
        endDate,
        page,
        limit,
        userId,
        apartmentId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IntercomDeviceLogServiceApi.getIntercomDeviceAuditLogs']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    async getMultipleDevicesStatistics(
      deviceIds: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IntercomDeviceLogDeviceStatisticsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMultipleDevicesStatistics(
        deviceIds,
        startDate,
        endDate,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IntercomDeviceLogServiceApi.getMultipleDevicesStatistics']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    async getRecentActivities(
      deviceIds: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IntercomDeviceLogRecentActivitiesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentActivities(
        deviceIds,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IntercomDeviceLogServiceApi.getRecentActivities']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

export const IntercomDeviceLogServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = IntercomDeviceLogServiceApiFp(configuration);
  return {
    getIntercomDeviceAuditLogs(
      orgId: string,
      operationType?: string,
      status?: string,
      startDate?: string,
      endDate?: string,
      page?: string,
      limit?: string,
      userId?: string,
      apartmentId?: string,
      options?: any
    ): AxiosPromise<IntercomDeviceLogListResponse> {
      return localVarFp
        .getIntercomDeviceAuditLogs(
          orgId,
          operationType,
          status,
          startDate,
          endDate,
          page,
          limit,
          userId,
          apartmentId,
          options
        )
        .then(request => request(axios, basePath));
    },

    getMultipleDevicesStatistics(
      deviceIds: string,
      startDate?: string,
      endDate?: string,
      options?: any
    ): AxiosPromise<IntercomDeviceLogDeviceStatisticsResponse> {
      return localVarFp
        .getMultipleDevicesStatistics(deviceIds, startDate, endDate, options)
        .then(request => request(axios, basePath));
    },

    getRecentActivities(
      deviceIds: string,
      options?: any
    ): AxiosPromise<IntercomDeviceLogRecentActivitiesResponse> {
      return localVarFp
        .getRecentActivities(deviceIds, options)
        .then(request => request(axios, basePath));
    },
  };
};

export class IntercomDeviceLogServiceApi extends BaseAPI {
  public getIntercomDeviceAuditLogs(
    orgId: string,
    operationType?: string,
    status?: string,
    startDate?: string,
    endDate?: string,
    page?: string,
    limit?: string,
    userId?: string,
    apartmentId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return IntercomDeviceLogServiceApiFp(this.configuration)
      .getIntercomDeviceAuditLogs(
        orgId,
        operationType,
        status,
        startDate,
        endDate,
        page,
        limit,
        userId,
        apartmentId,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  public getMultipleDevicesStatistics(
    deviceIds: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return IntercomDeviceLogServiceApiFp(this.configuration)
      .getMultipleDevicesStatistics(deviceIds, startDate, endDate, options)
      .then(request => request(this.axios, this.basePath));
  }

  public getRecentActivities(deviceIds: string, options?: RawAxiosRequestConfig) {
    return IntercomDeviceLogServiceApiFp(this.configuration)
      .getRecentActivities(deviceIds, options)
      .then(request => request(this.axios, this.basePath));
  }
}
